/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPeopleGroupCircleOffAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zM9 17c-.871 0-1.67.398-2.226 1.055a7.965 7.965 0 0 0 5.22 1.944C11.893 18.285 10.55 17 9 17zM5.682 7.096A7.963 7.963 0 0 0 4 12c0 1.696.53 3.268 1.43 4.563A4.88 4.88 0 0 1 9 15c2.657 0 4.762 2.128 4.98 4.752a7.967 7.967 0 0 0 2.923-1.435l-3.31-3.31a3.178 3.178 0 0 0-1.164.3l-.858-1.806a5.04 5.04 0 0 1 .362-.154l-.541-.541A2.992 2.992 0 0 1 9 14a3 3 0 0 1-1.807-5.393zM12 4a7.96 7.96 0 0 0-4.904 1.682l2.35 2.35a3.003 3.003 0 0 1 2.52 2.52l.72.72.815-1.405a1 1 0 1 0-.368-1.366l-1.73-1.002A3 3 0 0 1 17 9a3 3 0 0 1-3.661 2.925l1.117 1.117A5.205 5.205 0 0 1 18.68 16.4 8 8 0 0 0 12 4zm-3.35 6.064a1 1 0 1 0 1.286 1.286z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPeopleGroupCircleOffAlt as PeopleGroupCircleOffAlt };
